import styled from "styled-components";

export const FlexWrapper = styled.div<{
  flexDirection?: "row" | "column";
  justifyContent?: "flex-end" | "flex-start";
  gap?: string;
}>`
  display: flex;
  flex-direction: ${(props) => props.flexDirection || "row"};
  justify-content: ${(props) => props.justifyContent || "flex-end"};
  gap:  ${(props) => props.gap || "inherit"};
`;
